<template>
  <article class="wrap">
    <h2 class="main-title">Libro de Reclamaciones</h2>
    <p class="main-parrafo">
      Este formato sirve para presentar una queja o reclamo frente a Gestión de
      Soluciones ContaFácil SAC (en adelante “ContaFácil”) en relación al
      servicio de plataforma virtual para operaciones comerciales entre los
      Usuarios y sus clientes. La plataforma virtual permite al usuario emitir
      comprobantes electrónicos y administrar sus negocios a través de la
      plataforma (en adelante, el “Servicio”). No es aplicable para quejas o
      reclamos, ni para quejas relacionadas con el servicio de que es provista
      por terceras empresas. Por cuanto ContaFácil no provee dichos servicios o
      productos. En cualquiera de estos casos, se recomienda al usuario revisar
      nuevamente el contrato, acuerdo o términos y condiciones celebrados o
      aceptados con dichas empresas y se proceda conforme a lo pactado.
    </p>
    <section class="content">
      <div class="content-header">
        <h3 class="header-title">Libro de Reclamaciones</h3>
        <p class="header-subtitle">
          Gestión de Soluciones <br />
          ContaFácil S. A. C.
        </p>
      </div>
      <form class="clauses" @submit.prevent="send">
        <ol type="I">
          <li class="item-roman">
            Identificación del Proveedor
          </li>
          <div class="table-wrap">
            <div>
              <p>PROVEEDOR</p>
            </div>
            <div>
              <p>
                Gestión de Soluciones ContaFácil SAC RUC N° 20606574801,
                domiciliado en Av. Paseo de la República 3195, Interior 504,
                distrito de San Isidro, Lima, Perú
              </p>
            </div>
          </div>
          <li class="item-roman">
            Identificación del Consumidor
          </li>
          <div class="table-wrap">
            <div>Nombres y apellidos</div>
            <div>
              <input type="text" v-model="request.fullName" required />
            </div>
            <div>Domicilio</div>
            <div><input type="text" v-model="request.address" required /></div>
            <div>DNI / CE / PASAPORTE</div>
            <div>
              <input type="text" v-model="request.documentNumber" required />
            </div>
            <div>Telefóno</div>
            <div>
              <input
                type="text"
                v-model="request.phone"
                required
                placeholder="+51999999999"
              />
            </div>
            <div>Correo electrónico</div>
            <div>
              <input
                type="email"
                v-model="request.email"
                required
                placeholder="micorreo@correo.com"
              />
            </div>
            <div>
              Indicación de que si actua como padre o madre, (en caso de menores
              de edad)
            </div>
            <div class="flex-content">
              <label>
                <input
                  type="radio"
                  value="Padre"
                  name="padre-radio"
                  v-model="request.parentIndication"
                />
                <span>Padre</span>
              </label>
              <label>
                <input
                  type="radio"
                  value="Madre"
                  name="madre-radio"
                  v-model="request.parentIndication"
                />
                <span>Madre</span>
              </label>
            </div>
          </div>
          <li class="item-roman">
            Identificación del bien contratado
          </li>
          <div class="table-wrap">
            <div>Marca con una opción</div>
            <div class="flex-content">
              <label>
                <input
                  type="radio"
                  value="Producto"
                  name="producto-radio"
                  v-model="request.itemType"
                />
                <span>Producto</span>
              </label>
              <label>
                <input
                  type="radio"
                  value="Servicio"
                  name="servicio-radio"
                  v-model="request.itemType"
                />
                <span>Servicio</span>
              </label>
            </div>
            <div>
              Descripción
            </div>
            <div>
              <textarea
                cols="30"
                rows="10"
                v-model="request.itemDescription"
                required
              ></textarea>
            </div>
          </div>
          <li class="item-roman">Indicación si es reclamo o queja</li>
          <div class="flex-content padding-y">
            <label>
              <input
                type="radio"
                value="Reclamo"
                v-model="request.complainType"
                required
              />
              <span>Reclamo</span>
            </label>
            <label>
              <input
                type="radio"
                value="Queja"
                v-model="request.complainType"
                required
              />
              <span>Queja</span>
            </label>
          </div>
          <p>
            Qué es un reclamo: Disconformidad relacionada al producto o servicio
            ofrecido por CONTAFÁCIL. <br />
            Qué es una queja: Disconformidad no relacionada a productos o
            servicios de CONTAFÁCIL; o malestar o descontento respecto a la
            atención al público.
          </p>
          <li class="item-roman">Detalle del reclamo o queja</li>
          <p>
            Desarrolle aquí su reclamo o queja. La extensión del cuadro es
            referencial. Usted puede ampliarla conforme lo necesite.
          </p>
          <textarea
            cols="30"
            rows="10"
            v-model="request.complainDetail"
            required
          ></textarea>
          <li class="item-roman">
            Medio por el que se desea recibir respuesta
          </li>
          <div class="table-wrap">
            <div class="full-w-grid flex-content">
              <label>
                <input
                  type="radio"
                  value="Correo electrónico"
                  v-model="request.comunicationWay"
                  required
                />
                <span>Correo electrónico</span>
              </label>
              <label>
                <input
                  type="radio"
                  value="Domicilio físico"
                  v-model="request.comunicationWay"
                  required
                />
                <span>Domicilio físico</span>
              </label>
            </div>
            <div>Correo Electrónico</div>
            <div>
              <input type="email" v-model="request.comunicationEmail" />
            </div>
            <div>Domicilio Físico</div>
            <div>
              <input type="text" v-model="request.comunicationAddress" />
            </div>
          </div>
          <li class="item-roman">Sobre la atención de su reclamo o queja</li>
          <div>
            <ul>
              <li>
                La presentación de un reclamo mediante este formulario no es
                obligatoria ni es la única vía existente y disponible para
                reclamar o quejarse. Usted tiene el derecho de presentarlo de
                forma convencional, mediante el libro de reclamaciones que
                ContaFácil tiene disponible en su domicilio indicado en el
                apartado I de este formato.
              </li>
              <li>
                Su reclamo se entenderá presentado el día en que lo envíe de
                manera virtual a través de este formato.
              </li>
              <li>
                Una vez enviado el reclamo o queja, ContaFácil le enviará una
                respuesta al correo electrónico o domicilio físico que usted
                indicó para fines de comunicaciones, indicando haber recibido su
                reclamo o queja, y enviando una copia del reclamo o queja,
                cumpliendo así la exigencia legal de entregar una copia del
                reclamo o queja.
              </li>
              <li>
                ContaFácil atenderá su comunicación dentro del plazo de 30 días
                calendarios, pudiendo extenderse este plazo por otro periodo
                igual, si la naturaleza y complejidad lo requiere, siempre que
                ContaFácil se lo comunique a usted formalmente. Las
                comunicaciones de ContaFácil se dirigirán al correo o domicilio
                que usted ha indicado.
              </li>
              <li>
                En caso de que no se encuentre conforme con la respuesta
                brindada, puede presentar una reiteración a su queja o reclamo
                adjuntando información adicional que permita un nuevo análisis.
              </li>
              <li>
                Le recordamos que en tanto tenga calidad de Consumidor, también
                puede acudir al Instituto Nacional de Defensa de la Competencia
                y de la Protección de la Propiedad Intelectual (Indecopi)u
              </li>
            </ul>
          </div>
          <li class="item-roman">Tratamiento de datos personales</li>
          <div>
            <p>
              Para atender su queja o reclamo, ContaFácil realiza tratamiento de
              datos personales con sujeción a la Ley 29733, Ley de Protección de
              Datos Personales, y su reglamento, el Decreto Supremo 003-2013-JUS
              (en adelante, a ambos, la “LEY”) y conforme a la siguiente
              política y condiciones:
            </p>
            <ol>
              <li>
                Los datos personales que facilite en este formulario son
                necesarios para poder atender su queja o reclamo.
              </li>
              <li>
                ContaFácil tratará sus datos personales para atender las
                necesidades de la atención de reclamos y quejas, para atender
                cualquier necesidad relacionada con cualquier proceso judicial,
                arbitral o administrativo derivado de la queja o reclamo y para
                atender cualquier fiscalización de la autoridad competente en
                materia de tratamiento de datos personales o protección de los
                derechos de los consumidores.
              </li>
              <li>
                El plazo máximo de almacenamiento de los DATOS PERSONALES podrá
                ser: a) de hasta 2 años para atender todas las necesidades del
                procedimiento de atención de la queja o reclamo; b) de hasta 5
                años para atender las necesidades derivadas de cualquier proceso
                judicial, administrativo o arbitral derivado o en relación con
                el reclamo o queja, cualquier fiscalización de una autoridad
                competente, o c) hasta que usted revoque su consentimiento
                formalmente. No obstante, si la revocatoria impide atender su
                queja o reclamo, ContaFácil no será responsable por ello.
                Producido cualquiera de dichos acontecimientos, CONTAFÁCIL
                eliminará sus datos personales y dejará de tratarlos.
              </li>
              <li>
                Sus datos podrán ser almacenados en el banco de datos “Libro de
                reclamaciones” de titularidad de CONTAFÁCIL e inscrito en el
                Registro Nacional de Tratamiento de Datos Personales.
              </li>
              <li>
                CONTAFÁCIL implementa las medidas administrativas, legales y
                tecnológicas con el fin de ejecutar un tratamiento seguro y
                confidencial de los datos personales, pero no puede garantizar
                que se encuentren completamente libre de accesos y tratamientos
                no autorizados e ilícitos cometidos por terceros ajenos a
                CONTAFÁCIL, debido a riesgos naturales y los propios del entorno
                virtual. La implementación de estas medidas administrativas,
                legales y tecnológicas constituyen deberes de medios y no de
                resultados. Como consecuencia de ello, CONTAFÁCIL no se
                responsabiliza en caso de que se materialicen dichos riesgos y
                se genere algún tipo de daño o perjuicio a usted o a su
                representado.
              </li>
              <li>
                CONTAFÁCIL garantiza el ejercicio de los derechos de acceso,
                rectificación, cancelación, oposición y los que contempla la
                ley, de la manera más amplia y sin costo alguno. Para tal fin,
                usted deberá enviar una comunicación al correo
                contacto@contafacil.pe que deberá incluir todo lo siguiente: a)
                nombres y apellidos y copia de tu documento de identidad (si se
                actúa a través de un representante legal, deberá acreditarse los
                documentos que acrediten dicha representación); b) Pedido
                concreto; c) domicilio o dirección electrónica a donde se deberá
                responder; d) Fecha y firma de quien envía la solicitud; e)
                Documentos que sustenten la petición, de ser el caso.
              </li>
              <li>
                CONTAFÁCIL podrá modificar los alcances del tratamiento de los
                datos personales, para lo cual previamente informará de dichas
                comunicaciones al correo o domicilio facilitado en el
                formulario. El usuario tiene el derecho de rechazar dicha
                modificación y revocar su consentimiento, a través del mecanismo
                descrito en el numeral 6 anterior.
              </li>
            </ol>
            <p>
              Al enviar su queja o reclamo usted otorga consentimiento previo,
              libre, informado e inequívoco para que CONTAFÁCIL realice el
              tratamiento de sus datos personales para las finalidades y en las
              condiciones señaladas a lo largo del presente apartado.
            </p>
            <div class="terms">
              <label>
                <input type="checkbox" v-model="terms" required />
                {{ request.fullName }}, doy consentimiento al tratamiento de
                datos personales
              </label>
            </div>
          </div>
        </ol>
        <button class="form-submit">Enviar</button>
      </form>
    </section>
  </article>
</template>
<script>
import { apiMonday } from "../api/mondayApi.js";
import Vue from "vue";
export default {
  name: "ComplainBook",
  data() {
    return {
      request: {
        fullName: "",
        address: "",
        documentNumber: "",
        phone: "",
        email: "",
        parentIndication: "",
        itemType: "",
        itemDescription: "",
        complainType: "",
        complainDetail: "",
        comunicationWay: "",
        comunicationEmail: "",
        comunicationAddress: ""
      },
      terms: false
    };
  },
  methods: {
    async send() {
      console.log(this.request);
      const column_values = {
        date: new Date()
          .toLocaleDateString()
          .split("/")
          .reverse()
          .join("-"),
        status: { label: this.request.complainType },
        texto_largo8: this.request.complainDetail,
        texto2: this.request.address,
        texto27: this.request.documentNumber,
        tel_fono: `${this.request.phone} ${
          this.request.phone.includes("+51") ? "PE" : ""
        }`,
        correo_electr_nico: `${this.request.email} ${this.request.email}`,
        estado: { label: this.request.parentIndication },
        estado9: { label: this.request.itemType },
        texto_largo7: this.request.itemDescription,
        estado2: { label: this.request.comunicationWay },
        texto7:
          this.request.comunicationEmail || this.request.comunicationAddress
      };
      const query = `mutation { create_item (board_id: 5667822727, group_id: "topics", item_name: "${
        this.request.fullName
      }", column_values: ${JSON.stringify(
        JSON.stringify(column_values)
      )} ) { id } }`;
      console.log(query);
      const res = await apiMonday.toMonday({ query });
      if (res.status === 200) {
        Vue.$toast.success("Formulario enviado");
        this.request = {
          fullName: "",
          address: "",
          documentNumber: "",
          phone: "",
          email: "",
          parentIndication: "",
          itemType: "",
          itemDescription: "",
          complainType: "",
          complainDetail: "",
          comunicationWay: "",
          comunicationEmail: "",
          comunicationAddress: ""
        };
        this.terms = false;
      }
      if (res.status >= 400) {
        Vue.$toast.error("Error al enviar el formulario");
      }
    }
  }
};
</script>
<style scoped>
li,
p {
  text-align: justify;
}
p {
  line-height: 1.2;
}
input[type="text"],
input[type="email"] {
  width: 100%;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  border: thin solid #8a8a8a;
  border-radius: 5px;
}
input[type="radio"] {
  margin-right: 0.5rem;
}
textarea {
  padding: 0.5rem 1rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
}
input:user-invalid,
textarea:user-invalid {
  border-color: red;
}
.wrap {
  padding: 2rem;
}
.main-title {
  font-size: 2rem;
  letter-spacing: 0.05em;
  line-height: 1.8;
}
.main-parrafo {
  font-size: 1rem;
  margin: 2rem 0;
}
.content {
  margin: 1rem 0 3rem;
}
.content-header {
  background-color: #0000ff;
  padding: 0.5rem 0 1.5rem;
}
.header-title,
.header-subtitle {
  color: #ffffff;
  text-align: center;
}
.header-title {
  font-size: 1.3rem;
  line-height: 1.5;
  text-transform: uppercase;
}
.header-subtitle {
  font-size: 1.1rem;
  font-weight: 500;
}
.clauses {
  color: #000000;
}
.item-roman {
  text-align: start;
  padding-inline-start: 1.5rem;
  font-weight: 500;
  margin-top: 1.8rem;
}
.table-wrap {
  display: grid;
  grid-template-columns: 2fr 4fr;
  /* border: thin solid #040404; */
}
.table-wrap > div {
  padding: 1rem 0;
  width: 100%;
  text-align: start;
}
.full-w-grid {
  grid-column: span 2;
}
.flex-content {
  display: flex;
  gap: 2rem;
  justify-content: flex-start;
  align-items: center;
}
.padding-y {
  padding: 1rem 0;
}
.terms {
  text-align: start;
}
.form-submit {
  background-color: #1fb3ac;
  color: #ffffff;
  border: thin solid #1fb3ac;
  border-radius: 5px;
  font-size: 1.2rem;
  padding: 0.5rem 4rem;
  cursor: pointer;
}
</style>
